module.exports = __webpack_public_path__ + "img/2wei.e06af5ab.png";